<app-spinner [loading]="spinnerService.loading$ | async"></app-spinner>
<div class="review-content-container">
  <div class="review-header-cancel">
    <span
      class="material-symbols-outlined review-close-icon"
      (click)="markAsReviewed('cancel')"
      >close</span
    >
  </div>
  <div class="review-header">
    <div>Review</div>
    <div class="review-header-locked" *ngIf="!showActions">
      <span class="material-symbols-outlined review-locked-icon">lock</span>
      <span class="review-header-locked-text">Archived</span>
    </div>
  </div>
  <div class="review-modal-tab-title">
    <span
      class="material-symbols-outlined review-symbol"
      [class.review-symbol-action]="showActions"
      [class.review-symbol-noaction]="!showActions"
    >
      comment </span
    ><span class="review-modal-tab-title-text">{{
      reviewDetail.category.linkText
    }}</span>
  </div>
  <div class="review-modal-content-area">
    <div class="review-modal-content-title">
      {{ reviewDetail.fullName.linkText }}
    </div>
    <div class="review-modal-main-content-area">
      <div class="review-modal-line">
        <div class="review-modal-line-label">
          {{ 'Created on' | translate }}
        </div>
        <div class="review-modal-line-value">{{ reviewDetail.createdOn }}</div>
      </div>
      <div class="review-modal-line">
        <div class="review-modal-line-label">{{ 'Tool type' | translate }}</div>
        <div class="review-modal-line-value">{{ reviewDetail.reviewType }}</div>
      </div>
      <div class="review-modal-line">
        <div class="review-modal-line-label">
          {{ 'Review rule' | translate }}
        </div>
        <div class="review-modal-line-value">{{ reviewDetail.reviewRule }}</div>
      </div>
      <div class="review-modal-line">
        <div class="review-modal-line-label">
          {{'More information | translate }}
        </div>
        <div class="review-modal-line-value">{{ reviewDetail.comments }}</div>
      </div>
    </div>
  </div>
  <div
    class="review-modal-button-area"
    [class.review-modal-button-area-reviewed]="!showActions"
  >
    <app-action-button
      kind="outline"
      color="primary"
      size="wide"
      (onClick)="markAsReviewed('continue')"
    >
      <span class="review-modal-button-area-button">
        <span class="material-symbols-outlined review-button-icon">done</span>
        <span class="review-modal-button-text">Mark as reviewed</span>
      </span></app-action-button
    >
  </div>
</div>
